import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { makeCRMApi } from '../CrmApi';
import { SECONDS } from 'utils';

export const useUnviewedNotificationsCount = (urlLocation: string) => {
  const crmApi = makeCRMApi();
  
  const unviewedNotificationsCount = useQuery({
    queryKey: ['unviewed-notifications-count', urlLocation],
    queryFn: () =>
      crmApi.getUnviewedNotificationsCount(),
    refetchInterval: 60 * SECONDS,
    placeholderData: keepPreviousData,
    refetchOnMount: true,
    staleTime: 0,
    gcTime: 0,
  });
  
  return {
    unviewedNotificationsCount: unviewedNotificationsCount.data?.data.count ?? 0,
    unviewedNotificationsCountQuery: unviewedNotificationsCount,
  };
}
